import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import OnlineStatus from '../OnlineStatus';

class ChatHeader extends PureComponent {
  render() {
    const { status } = this.props;

    return (
      <div className="header" onClick={this.props.onClick}>
        <div className="room-name">
          <OnlineStatus status={status} /> {this.props.children}
        </div>
        <div className="room-ctrl" onClick={this.props.close}>
          <i className="zmdi zmdi-hc-fw zmdi-close" title="Hide" />
        </div>
        <div className="room-ctrl minimize" onClick={this.props.minimize}>
          <i className="zmdi zmdi-hc-fw zmdi-window-minimize" title="Minimize" />
        </div>
      </div>
    );
  }
}

ChatHeader.propTypes = {
  children: PropTypes.string,
  close: PropTypes.func,
  onClick: PropTypes.func,
  minimize: PropTypes.func,
  status: PropTypes.oneOf(['Available', 'Offline', 'Busy', 'Away']),
};

export default ChatHeader;
